interface UrlParams {
  hideUI: boolean;
}

export const getUrlParams = (): UrlParams => {
  const urlSearch = new URLSearchParams(window.location.search);

  const hideUIParam = urlSearch.get('pdHideUI');
  const hideUI = hideUIParam === 'true' || hideUIParam === '1';

  return {
    hideUI,
  };
};
